module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bolditalic-webfont.3e9b2343.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bolditalic-webfont.ttf
// module id = 385
// module chunks = 3